import { render, staticRenderFns } from "./form_draw.vue?vue&type=template&id=e130b450&"
import script from "./form_draw.vue?vue&type=script&lang=js&"
export * from "./form_draw.vue?vue&type=script&lang=js&"
import style0 from "./form_draw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports